import { render, staticRenderFns } from "./WorkflowRequestList.vue?vue&type=template&id=442db01a&scoped=true"
import script from "./WorkflowRequestList.vue?vue&type=script&lang=js"
export * from "./WorkflowRequestList.vue?vue&type=script&lang=js"
import style0 from "./WorkflowRequestList.vue?vue&type=style&index=0&id=442db01a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442db01a",
  null
  
)

export default component.exports